import { Box, Button, Container, Grid, IconButton, Chip } from "@mui/material";
import React, { useState, useEffect, useCallback } from "react";
import { useQuery, useQueryClient } from "react-query";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import Iconify from "src/components/Iconify";
import Page from "src/components/Page";
import MRTTable from "src/components/mrt-table";
import useSettings from "src/hooks/useSettings";
import { getAllChecklistCategories } from "src/pages/api";
import AddCategory from "./addcategory";
import DeleteRecord from "src/components/DeleteRecord";

const columns = [
  {
    accessorKey: "name",
    header: "Name",
    size: 300,
  },
  // {
  //   accessorKey: "isActive",
  //   header: "Status",
  //   size: 150,
  //   Cell: ({ cell }) => (
  //     <Chip
  //       label={cell.getValue() ? "Active" : "Inactive"}
  //       color={cell.getValue() ? "success" : "default"}
  //       size="small"
  //     />
  //   ),
  // },
];

export default function ChecklistCategoryMaster() {
  const { themeStretch } = useSettings();
  const queryClient = useQueryClient();

  const [open, setOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [globalFilter, setGlobalFilter] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(globalFilter);
      setPagination(prev => ({ ...prev, pageIndex: 0 }));
    }, 500);
    return () => clearTimeout(timer);
  }, [globalFilter]);

  const { data, isLoading, refetch, isFetching } = useQuery({
    queryKey: ["checklist-categories", pagination.pageIndex, pagination.pageSize, debouncedSearch],
    queryFn: getAllChecklistCategories,
    keepPreviousData: true,
    staleTime: 0,
  });

  const handleRowClick = (row) => {
    setOpen(true);
    setSelectedRow(row.original);
    setIsEditMode(true);
  };

  const handlePaginationChange = useCallback((updater) => {
    setPagination((prev) => {
      const newState = typeof updater === "function" ? updater(prev) : updater;
      return newState;
    });
  }, []);

  return (
    <>
      {open && (
        <AddCategory
          onClose={() => {
            setOpen(false);
            setSelectedRow(null);
            setIsEditMode(false);
            refetch();
          }}
          row={selectedRow}
          isEditMode={isEditMode}
        />
      )}
      {openDelete && selectedRow && (
        <DeleteRecord
          row={selectedRow}
          title="Delete Category"
          labelKey="name"
          endpoint="/checklist-categories"
          queryKey={["checklist-categories"]}
          onClose={() => {
            setOpenDelete(false);
            setSelectedRow(null);
            refetch();
          }}
        />
      )}
      <Page title="Checklist Category">
        <Container maxWidth={themeStretch ? false : "xl"}>
          <HeaderBreadcrumbs
            heading="Checklist Categories"
            links={[
              // { name: "Dashboard", href: PATH_DASHBOARD.root },
              { name: "Master" },
              { name: "Checklist Categories" },
            ]}
          />
          <Grid container spacing={3}>
            <Grid item xs={12} sx={{ overflowX: "auto", minWidth: 0 }}>
              <MRTTable
                data={data?.data || []}
                columns={columns}
                manualPagination={true}
                loading={isLoading || isFetching}
                onPaginationChange={handlePaginationChange}
                pagination={pagination}
                rowCount={data?.total || 0}
                onGlobalFilterChange={setGlobalFilter}
                muiTableBodyRowProps={({ row }) => ({
                  onClick: () => handleRowClick(row),
                  sx: {
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "action.hover" },
                  },
                })}
                renderRowActions={({ row }) => (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenDelete(true);
                        setSelectedRow(row.original);
                      }}
                      color="error"
                      size="small"
                    >
                      <Iconify icon={"eva:trash-2-outline"} />
                    </IconButton>
                  </Box>
                )}
                renderTopToolbarCustomActions={() => (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => {
                        setOpen(true);
                        setIsEditMode(false);
                      }}
                      sx={{ minWidth: "120px", fontSize: "0.875rem", py: 1 }}
                    >
                      Add New
                    </Button>
                  </Box>
                )}
                enableToolbarInternalActions={false}
                enableTopToolbar={true}
                enableBottomToolbar={true}
                enableColumnActions={false}
                enableColumnFilters={false}
                enableSorting={true}
                enableGlobalFilter={true}
                enableHiding={false}
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                enablePagination={true}
                positionPagination="bottom"
                enableColumnDragging={false}
                positionGlobalFilter="left"
                muiSearchTextFieldProps={{
                  placeholder: "Search",
                  size: "small",
                  variant: "outlined",
                  // sx: { minWidth: "250px" },
                  value: globalFilter,
                  onChange: (e) => setGlobalFilter(e.target.value),
                }}
                initialState={{
                  showGlobalFilter: true,
                  density: "comfortable",
                  pagination: { pageSize: 10, pageIndex: 0 },
                }}
                state={{
                  globalFilter,
                  pagination,
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </Page>
    </>
  );
}
